const state = {
  showGuidance: false,
  adjustmentResult: null,
  currentLockIndex: 0,
  completedLocks: [],
  skippedLocks: []
}

const getters = {
  affectedSpotLocks(state) {
    if (!state.adjustmentResult?.allocationChanges) return []
    
    // Process rich allocation change data from backend
    return state.adjustmentResult.allocationChanges.map(change => ({
      ...change.spotLockTransaction,  // full spot lock data
      allocationChange: change,       // include change details
      priority: change.priority,
      suggestedAction: change.suggestedAction
    }))
  },
  
  currentSpotLock(state, getters) {
    return getters.affectedSpotLocks[state.currentLockIndex] || null
  },
  
  guidanceProgress(state, getters) {
    return {
      current: state.currentLockIndex + 1,
      total: getters.affectedSpotLocks.length,
      completed: state.completedLocks.length,
      skipped: state.skippedLocks.length,
      remaining: getters.affectedSpotLocks.length - state.completedLocks.length - state.skippedLocks.length
    }
  }
}

const mutations = {
  INITIALIZE_GUIDANCE(state, { adjustmentResult }) {
    state.showGuidance = true
    state.adjustmentResult = adjustmentResult
    state.currentLockIndex = 0
    state.completedLocks = []
    state.skippedLocks = []
  },
  
  SET_CURRENT_LOCK_INDEX(state, index) {
    state.currentLockIndex = index
  },
  
  MARK_LOCK_COMPLETED(state, lockId) {
    state.completedLocks.push(lockId)
  },
  
  MARK_LOCK_SKIPPED(state, lockId) {
    state.skippedLocks.push(lockId)
  },
  
  RESET_GUIDANCE(state) {
    state.showGuidance = false
    state.adjustmentResult = null
    state.currentLockIndex = 0
    state.completedLocks = []
    state.skippedLocks = []
  }
}

const actions = {
  initializeGuidance({ commit }, payload) {
    commit('INITIALIZE_GUIDANCE', payload)
  },
  
  navigateToLock({ commit }, index) {
    commit('SET_CURRENT_LOCK_INDEX', index)
  },
  
  markLockCompleted({ commit, state, getters }, lockId) {
    commit('MARK_LOCK_COMPLETED', lockId)
    
    // Navigate to next lock if available
    const nextIndex = state.currentLockIndex + 1
    if (nextIndex < getters.affectedSpotLocks.length) {
      commit('SET_CURRENT_LOCK_INDEX', nextIndex)
    }
  },
  
  markLockSkipped({ commit, state, getters }, lockId) {
    commit('MARK_LOCK_SKIPPED', lockId)
    
    // Navigate to next lock if available
    const nextIndex = state.currentLockIndex + 1
    if (nextIndex < getters.affectedSpotLocks.length) {
      commit('SET_CURRENT_LOCK_INDEX', nextIndex)
    }
  },
  
  resetGuidance({ commit }) {
    commit('RESET_GUIDANCE')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
